import type { ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';

export interface ContainerProps {
  children: ReactNode;
  /** Defaults to --portal-content-max (1280px, measured from the prototype). */
  max?: string;
  className?: string;
}

/** Page measure and side padding. Padding drops to 16px below --bp-drawer. */
export function Container({ children, max, className }: ContainerProps) {
  return (
    <div
      className={['container', className].filter(Boolean).join(' ')}
      style={styleVars({ '--max': max })}
    >
      {children}
    </div>
  );
}
